
const nameList = [
    {
        entityField: "storeName",
        showField: "门店名称",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "storeAddress",
        showField: "门店地址",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "storeArea",
        showField: "门店区域",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "storeCode",
        showField: "门店编码",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "storeManrangeName",
        showField: "经营范围",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "stName",
        showField: "库房",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "dsStName",
        showField: "电商库房",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "autoPrint",
        showField: "是否自动打印小票",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "scanCode",
        showField: "是否扫电子监管码",
        fieldWeight: 130,
        fieldType: "string",
    },
    {
        entityField: "autoPayMoney",
        showField: "是否带出收银金额",
        fieldWeight: 130,
        fieldType: "string",
    },
    {
        entityField: "isChangePriceCheck",
        showField: "修改单价是否验证",
        fieldWeight: 130,
        fieldType: "string",
    },
    {
        entityField: "groupName",
        showField: "价格组",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "storePerson",
        showField: "门店负责人",
        fieldWeight: 100,
        fieldType: "string",

    },

    {
        entityField: "storePhone",
        showField: "联系电话",
        fieldWeight: 130,
        fieldType: "string",

    },
    {
        entityField: "storeState",
        showField: "门店状态",
        fieldWeight: 100,
        fieldType: "string",

    },
    {
        entityField: "storeType",
        showField: "门店类型",
        fieldWeight: 130,
        fieldType: "string",

    },


    {
        entityField: "coName",
        showField: "货主",
        fieldWeight: 130,
        fieldType: "string",

    },
    // {
    //     entityField: "createrName",
    //     showField: "创建人",
    //     fieldWeight: 130,
    //     fieldType: "string",
    //     isRift: 1,
    //     riftField: "bgmId",

    // },
    // {
    //     entityField: "memDayType",
    //     showField: "会员日类型",
    //     fieldWeight: 160,
    //     fieldType: "string",

    // },
    // {
    //     entityField: "memDay",
    //     showField: "会员日",
    //     fieldWeight: 130,
    //     fieldType: "string",

    // },
    {
        entityField: "memDayStr",
        showField: "会员日",
        fieldWeight: 130,
        fieldType: "string",

    },

    {
        entityField: "periodValidity",
        showField: "经营许可证有效期",
        fieldWeight: 140,
        fieldType: "string",

    },
    {
        entityField: "pointMultiply",
        showField: "积分倍数",
        fieldWeight: 80,
        fieldType: "string",

    },
    {
        entityField: "pointRatio",
        showField: "积分系数",
        fieldWeight: 80,
        fieldType: "string",

    },

    // {
    //     entityField: "reserves1",
    //     showField: "预留1",
    //     fieldWeight: 130,
    //     fieldType: "string",

    // },
    // {
    //     entityField: "reserves2",
    //     showField: "预留2",
    //     fieldWeight: 130,
    //     fieldType: "string",

    // },
    // {
    //     entityField: "reserves3",
    //     showField: "预留3",
    //     fieldWeight: 130,
    //     fieldType: "string",

    // },
    // {
    //     entityField: "stName",
    //     showField: "库房",
    //     fieldWeight: 130,
    //     fieldType: "string",

    // },
    


]


const peopleList = [

    {
        entityField: "opmName",
        showField: "人员名称",
        fieldWeight: 160,
        fieldType: "string",

    },
    {
        entityField: "opmMobilenumber",
        showField: "手机号",
        fieldWeight: 130,
        fieldType: "string",

    },
    // {
    //     entityField: "opmIdnumber",
    //     showField: "身份证号",
    //     fieldWeight: 130,
    //     fieldType: "string",

    // },
]
const  searchList= [
    // {
    //     showField: "开始时间",
    //     entityField: "start",
    //     isShow: 1,
    //     fieldType: "date",
    //     formatterContent: null,
    //     isRift: null,
    //     riftField: null,
    //     fieldWeight: 120,
    // },
    // {
    //     showField: "结束时间",
    //     entityField: "end",
    //     isShow: 1,
    //     fieldType: "date",
    //     formatterContent: null,
    //     isRift: null,
    //     riftField: null,
    //     fieldWeight: 120,
    // },
    // {
    //     showField: "门店名称",
    //     entityField: "storeName",
    //     isShow: 1,
    //     fieldType: "search",
    //     searchId: 293839281728,
    //     formatterContent: null,
    //     isRift: null,
    //     riftField: null,
    //     setField: "storeName,storeId",
    //     fieldWeight: 120,
    // },
    {
        showField: "门店名称",
        entityField: "storeName",
        isShow: 1,
        fieldType: "string",
        searchId: null,
        formatterContent: null,
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },

    // {
    //     showField: "货主",
    //     entityField: "coName",
    //     isShow: 1,
    //     fieldType: "search",
    //     searchId: 4414428383875072,
    //     formatterContent: null,
    //     isRift: null,
    //     riftField: null,
    //     setField:  "coName,coId",
    //     fieldWeight: 120,
    // },
    // {
    //     showField: "价格组",
    //     entityField: "groupName",
    //     isShow: 1,
    //     fieldType: "search",
    //     searchId: 8820873997127709,
    //     formatterContent: null,
    //     isRift: null,
    //     riftField: null,
    //     setField:  "groupName,groupPriceId",
    //     fieldWeight: 120,
    // },
    {
        showField: "门店类型",
        entityField: "storeType",
        isShow: 1,
        fieldType: "select",
        searchId: null,
        formatterContent: [
            {
                key: "单体",
                value: '单体',
            },
            {
                key: "加盟",
                value: "加盟",
            },
            {
                key: "直营",
                value: "直营",
            },
            {
                key: "批零一体",
                value: "批零一体",
            },
        ],
        isRift: null,
        riftField: null,
        setField: null,
        fieldWeight: 120,
    },
]




// 门店列表
// 业务员列表
export {nameList, peopleList,searchList}